import { Info } from 'luxon';

export async function injectIntlAndTimezonePolyfill() {
  const { intl, zones } = Info.features();

  if (!intl) {
    await import('intl');
    await import(`intl/locale-data/jsonp/en.js`);
  }
  if (!zones) {
    await import('date-time-format-timezone');
  }
}
